import { createFileRoute } from '@tanstack/react-router'

import { ClassAddView } from '@/modules/classes'

export const Route = createFileRoute(
  '/_auth/students-and-classes/classes/add/'
)({
  component: ClassAddView
})
